export const HRCV_FREE_DATA = 'HRCV_FREE_DATA'

export const HRCV_SET_CV_LOADING_STATE = 'HRCV_SET_CV_LOADING_STATE'
export const HRCV_GET_CURRENT_CV = 'HRCV_GET_CURRENT_CV'

export const HRCV_SET_CV_FILTER = 'HRCV_SET_CV_FILTER' // Установка фильтра статуса анкет
export const HRCV_CLEAR_CV_LIST = 'HRCV_CLEAR_CV_LIST' // Очистка списка анкет
export const HRCV_GET_CV_LIST = 'HRCV_GET_CV_LIST' // Получение списка анкет, согласно установленному текущему фильтру

export const HRCV_POST_CV = 'HRCV_POST_CV' // Изменение состояния анкеты

export const HRCV_GET_CV_STATUS_LIST = 'HRCV_GET_CV_STATUS_LIST'
export const HRCV_GET_CV_TYPES_LIST = 'HRCV_GET_CV_TYPES_LIST'
export const HRCV_SET_CURRENT_CV = 'HRCV_SET_CURRENT_CV'
export const HRCV_CREATE_CV = 'HRCV_CREATE_TEST' // Создание нового теста (аттестации)
export const HRCV_CANCEL_CV = 'HRCV_CANCEL_TEST' // Удалить тест (аттестацию)

export const HRCV_GET_QUESTIONS = 'HRCV_GET_QUESTIONS' // Получение списка вопросов по анкете
export const HRCV_ADD_QUESTION = 'HRCV_ADD_QUESTION' // Добавление вопроса в анкету
export const HRCV_UPD_QUESTION = 'HRCV_UPD_QUESTION' // Обновление вопроса в анкете
export const HRCV_DEL_QUESTION = 'HRCV_DEL_QUESTION' // Удаление вопроса из анкеты
export const HRCV_SET_CURRENT_Q = 'HRCV_SET_CURRENT_Q'

export const HRCV_ADD_ANSWER = 'HRCV_ADD_ANSWER' // Добавление ответа в вопрос анкеты
export const HRCV_UPD_ANSWER = 'HRCV_UPD_ANSWER' // Обновление ответа в вопросе анкеты
export const HRCV_DEL_ANSWER = 'HRCV_DEL_ANSWER' // Удаление ответа из вопроса анкеты
export const HRCV_SET_CURRENT_A = 'HRCV_SET_CURRENT_A'

export const HRCV_GET_ANSWERS = 'HRCV_GET_ANSWERS' // Ответы на вопросы, анкета

export const HRCV_ADD_VACANCY = 'HRCV_ADD_VACANCY' // Добавление вакансии
export const HRCV_UPD_VACANCY = 'HRCV_UPD_VACANCY' // Редактирование вакансии
export const HRCV_GET_VACANCY_STATES = 'HRCV_GET_VACANCY_STATES' // Получение списка статусов вакансий
export const HRCV_GET_VACANCY_ACTIONS = 'HRCV_GET_VACANCY_ACTIONS' // Получение списка действий по вакансиям
export const HRCV_POST_VACANCY = 'HRCV_POST_VACANCY' // Изменение состояния вакансии
export const HRCV_GET_VACANCY_LIST = 'HRCV_GET_VACANCY_LIST' // Получение списка вакансий
export const HRCV_CLEAR_VACANCY_LIST = 'HRCV_CLEAR_VACANCY_LIST' // Очистка списка вакансий
export const HRCV_GET_VACANCY_ROUTE = 'HRCV_GET_VACANCY_ROUTE' // Получение маршрута вакансий
export const HRCV_SET_CURRENT_VACANCY = 'HRCV_SET_CURRENT_VACANCY' // Установка текущей вакансии
export const HRCV_SET_VACANCY_LOADING_STATE = 'HRCV_SET_VACANCY_LOADING_STATE' // Установка состояния загрузки списка вакансий
export const HRCV_SET_VACANCY_FILTER = 'HRCV_SET_VACANCY_FILTER' // Установка фильтра статуса вакансий
